import styled from '@emotion/styled';
import {LabelLargeBold} from '@travel-frontend/ui-components';

export const SubTitle = styled(LabelLargeBold)`
  font-weight: 600;
  line-height: 1;
  letter-spacing: 1px;
  color: ${({theme}) => theme.colors.contentInversePrimary};
`;
